import { useState } from "react";
import { useIntl } from "react-intl";
import { Space, Checkbox } from "antd";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteComponent";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStaffInCharge } from "../PatientsSlice";

const Header = () => {
  const { branchId } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showInactive, setShowInactive] = useState(false);
  const staffFilter = {
    filter: {
      $and: [
        { staff_member: true },
        {
          $or: showInactive ? [{ status: 1 }, { status: 2 }] : [{ status: 1 }],
        },
      ],
    },
  };

  const onShowInactiveChange = (e) => {
    setShowInactive(e.target.checked);
  };

  const onStaffChange = (val) => {
    dispatch(setStaffInCharge(val));
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 10px",
      }}
    >
      <Space direction="horizontal">
        <EmployeesSelect
          size="large"
          placeholder={intl.formatMessage({
            id: `app.gaps.search_by_staff`,
          })}
          style={{ width: 150 }}
          onChange={onStaffChange}
          allowClear
          extraParams={{
            ...staffFilter,
            scopePrefix: branchId ? `branches/${branchId}/` : ``,
          }}
        />

        <Checkbox
          style={{ margin: "0 20px" }}
          onChange={onShowInactiveChange}
          checked={showInactive}
        >
          {intl.formatMessage({
            id: `app.actions.include_inactive`,
          })}
        </Checkbox>
      </Space>
    </div>
  );
};

export default Header;
